<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          Create User Guide
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <div class="mb-4">
              <v-text-field v-model="formData.guide_title" label="Guide Main Title" variant="outlined"
                density="compact" :rules="[(v) => !!v || 'Guide Main Title is required']" />
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">
            Cancel
          </v-btn>
          <v-btn color="primary" variant="flat" :loading="loading" @click="handleSubmit">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_user_guide_topic } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "CreateUserGuideDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,

      formData: {
        guide_title: "",
        guide_topic_status: "ACTIVE",
      },

      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        guide_title: "",
        guide_topic_status: "ACTIVE",
      };

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      this.loading = true;

      try {
        const input = {
          title: this.formData.guide_title,
        };

        const response = await client.graphql({
          query: create_user_guide_topic,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.create_user_guide_topic);

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Checklist created successfully",
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message || "Failed to create checklist",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating checklist:", error);
        this.snackbar = {
          show: true,
          message:
            error.message || "An error occurred while creating the checklist",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped>
</style>
